<template>
  <div class="qa-list-block">
    <h4 v-show="title.length > 0" class="qa-block-title">{{ title }}</h4>
    <QAListItem v-for="(item, i) in data" :item="item" :path="{ name: 'QuestionDetail', params: { id: item.id} }" :key="i" />
    <div v-if="data && !data.length" class="qa-no-result text-center mt-40">
      <p v-html="noResultMsg"></p>
    </div>
  </div>
</template>

<script>
import QAListItem from '../components/list-item';

export default {
  name: 'QAListBlock',
  components: {
    QAListItem
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    noResultMsg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      data: null
    };
  },
  watch: {
    items: function(value) {
      this.data = value;
    }
  }
};
</script>
